import { BridgeComponent, Message } from '@hotwired/hotwire-native-bridge';

interface HealthkitCheckResponseData {
  status: string;
}

interface HealthkitCheckResponseMessage extends Message {
  data: HealthkitCheckResponseData;
}

export default class HealthkitController extends BridgeComponent {
  public static component = 'healthkit';

  public connect(): void {
    // This emits virtualtrails.healthkit_authorization_* on document
    this.send(
      'check',
      {},
      ({ data: { status } }: HealthkitCheckResponseMessage) => {
        console.log(`Healthkit status: ${status}`);
        document.dispatchEvent(
          new Event(`virtualtrails.healthkit_authorization_${status}`)
        );
      }
    );
  }

  public authorize(e: Event): void {
    if (e.target && 'disabled' in e.target) {
      e.target.disabled = true;
    }

    this.send('authorize');
  }

  public hide(): void {
    this.element.classList.add('d-none');
  }

  public show(): void {
    this.element.classList.remove('d-none');
  }
}
